/**
 * Subscriber Forms — Newsletter + Gated Download
 * Shared AJAX handler for both form types
 */

const initSubscriberForms = () => {
  // Handle all subscriber forms
  document.querySelectorAll('.nm-subscriber-form').forEach((form) => {
    form.addEventListener('submit', handleFormSubmit);
  });

  // Handle gated download trigger buttons
  document.querySelectorAll('.gated-download__trigger').forEach((btn) => {
    btn.addEventListener('click', handleDownloadTrigger);
  });

  // Handle gated download close buttons
  document.querySelectorAll('.gated-download__close').forEach((btn) => {
    btn.addEventListener('click', handleDownloadClose);
  });

  // Show confirmation message from URL params (after redirect)
  showFlashMessage();
};

/**
 * Show form overlay on download card
 */
const handleDownloadTrigger = (e) => {
  const card = e.currentTarget.closest('.gated-download__card');
  if (!card) return;

  const wrapper = card.querySelector('.gated-download__form-wrapper');
  if (!wrapper) return;

  wrapper.classList.add('-visible');

  const input = wrapper.querySelector('input[type="email"]');
  if (input) input.focus();
};

/**
 * Hide form overlay on download card
 */
const handleDownloadClose = (e) => {
  const wrapper = e.currentTarget.closest('.gated-download__form-wrapper');
  if (!wrapper) return;

  wrapper.classList.remove('-visible');
};

/**
 * Handle form submission via AJAX
 */
const handleFormSubmit = async (e) => {
  e.preventDefault();

  const form = e.currentTarget;
  const action = form.dataset.action;
  const submitBtn = form.querySelector('.nm-subscriber-form__submit');
  const feedback = form.querySelector('.nm-subscriber-form__feedback');
  const messageEl = form.querySelector('.nm-subscriber-form__message');

  // Client-side email validation
  const emailInput = form.querySelector('input[name="email"]');
  if (!emailInput || !emailInput.value || !emailInput.validity.valid) {
    showFeedback(feedback, messageEl, 'Veuillez entrer une adresse email valide.', 'error');
    return;
  }

  // GDPR consent check
  const consentInput = form.querySelector('input[name="gdpr_consent"]');
  if (consentInput && !consentInput.checked) {
    showFeedback(feedback, messageEl, 'Vous devez accepter la politique de confidentialité.', 'error');
    return;
  }

  // Disable button + show loader
  submitBtn.classList.add('-loading');
  submitBtn.disabled = true;

  const formData = new FormData(form);
  formData.append('action', action);
  formData.append('nonce', window.nmSubscriber?.nonce || '');

  try {
    const response = await fetch(window.nmSubscriber?.ajaxUrl || '/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData,
    });

    const result = await response.json();
    const message = result.data?.message || 'Une erreur est survenue.';
    const type = result.success ? 'success' : 'error';

    showFeedback(feedback, messageEl, message, type);

    if (result.success) {
      form.reset();

      // If download URL returned (already confirmed), trigger download
      if (result.data?.download_url) {
        window.location.href = result.data.download_url;
      }
    }
  } catch {
    showFeedback(feedback, messageEl, 'Erreur de connexion. Veuillez réessayer.', 'error');
  } finally {
    submitBtn.classList.remove('-loading');
    submitBtn.disabled = false;
  }
};

/**
 * Show feedback message
 */
const showFeedback = (container, messageEl, text, type) => {
  if (!container || !messageEl) return;

  messageEl.textContent = text;
  container.removeAttribute('hidden');
  container.className = `nm-subscriber-form__feedback -${type}`;
};

/**
 * Show flash message from URL params after confirmation redirect
 */
const showFlashMessage = () => {
  const params = new URLSearchParams(window.location.search);
  const message = params.get('nm_message');
  const type = params.get('nm_type');

  if (!message) return;

  const banner = document.createElement('div');
  banner.className = `nm-flash-message -${type === 'error' ? 'error' : 'success'}`;
  banner.setAttribute('role', 'alert');
  banner.innerHTML = `<p>${decodeURIComponent(message)}</p><button type="button" class="nm-flash-message__close" aria-label="Fermer">&times;</button>`;

  document.body.prepend(banner);

  banner.querySelector('.nm-flash-message__close').addEventListener('click', () => {
    banner.remove();
  });

  // Auto-dismiss after 8s
  setTimeout(() => {
    banner.remove();
  }, 8000);

  // Clean URL
  const cleanUrl = window.location.pathname;
  window.history.replaceState({}, '', cleanUrl);
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSubscriberForms);
} else {
  initSubscriberForms();
}

export default initSubscriberForms;
